import StorefrontIcon from "@mui/icons-material/Storefront";
import { Box, Divider, Stack, Typography, alpha, useTheme } from "@mui/material";

import { marketplaceTypography as mt } from "../constants/marketplaceTypography";
import type { WooStoreConfig } from "../types";

interface MarketplaceStoreGroupHeaderProps {
  store: WooStoreConfig;
  /** Carrinho: contagem de itens; Pedidos: "2 pedidos" */
  metaLabel: string;
  /** Opcional: subtotal da loja (carrinho) */
  trailing?: string;
}

/** Cabeçalho de grupo por loja — logo, nome e meta (itens/pedidos). */
export function MarketplaceStoreGroupHeader({
  store,
  metaLabel,
  trailing,
}: MarketplaceStoreGroupHeaderProps) {
  const theme = useTheme();

  return (
    <Box>
      <Stack direction="row" spacing={1.25} alignItems="center" sx={{ pb: 1 }}>
        {(store.logoDataUrl ?? store.logoUrl) ? (
          <Box
            component="img"
            src={store.logoDataUrl ?? store.logoUrl}
            alt={store.name}
            sx={{
              width: 36,
              height: 36,
              objectFit: "contain",
              flexShrink: 0,
            }}
          />
        ) : (
          <Box
            sx={{
              width: 36,
              height: 36,
              borderRadius: 1,
              bgcolor: alpha(theme.palette.primary800.main, 0.1),
              color: "primary800.main",
              display: "grid",
              placeItems: "center",
              flexShrink: 0,
            }}
          >
            <StorefrontIcon sx={{ fontSize: 20 }} />
          </Box>
        )}
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography sx={{ ...mt.label, color: "primary800.main" }} noWrap>
            {store.name}
          </Typography>
          <Typography sx={{ ...mt.bodySecondary, color: "text.secondary" }}>
            {metaLabel}
            {trailing ? ` · ${trailing}` : ""}
          </Typography>
        </Box>
      </Stack>
      <Divider sx={{ opacity: 0.6, mb: 0.25 }} />
    </Box>
  );
}
